import React from 'react';
import Title from 'components/TitleWithIcon';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import {useStyles} from './styles';
import StepperCensus from './stepperCensus';
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import { AppBar, Toolbar, IconButton, Typography, Button,} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useHistory } from "react-router-dom";
import allActions from 'store/actions';
import { useSelector, useDispatch } from 'react-redux'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function SolicitudesEmpadronamientoDelegacionDialog(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    let history = useHistory();
    const ConsultaDeDatosARenap = () =>{
        let datosSolicitudGeneradoNancional = {datosSolicitudGeneradoNancional:{cui: '', usuario: ''}}
        dispatch(allActions.solicitudDatosGenerado(datosSolicitudGeneradoNancional))
        props.handleClose()
        history.push("/ConsultaSolicitud",{})
    }

    const handleClose = () => {
        let datosSolicitudGeneradoNancional = {datosSolicitudGeneradoNancional:{cui: '', usuario: ''}}
        dispatch(allActions.solicitudDatosGenerado(datosSolicitudGeneradoNancional))
        props.handleClose(true)
    }
    return (
        <div>
            <Dialog  
                open={props.open}
                // maxWidth={"md"}
                // fullWidth={true}
                fullScreen 
                TransitionComponent={Transition}
                keepMounted
                // onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                disableBackdropClick={true}
                disableEscapeKeyDown={true}
            >
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                            {props.isInscripcionActualizacion}  
                        </Typography>
                        <Button autoFocus color="inherit" onClick={ConsultaDeDatosARenap}>Consulta de Datos a RENAP</Button>                        
                    </Toolbar>
                </AppBar>
                <Title title={props.isInscripcionActualizacion} icon={"/menu/Document.png"}/>
                <StepperCensus
                    actualizarTabla={props.actualizarTabla}
                    cerrarDialogo={props.handleClose}
                    {...props}
                    // ObtenerTotalDeSolicitudesPendientesDeRealizar={props.ObtenerTotalDeSolicitudesPendientesDeRealizar}
                    AbrirModalProcesarSolicitudExtranjero={props.AbrirModalProcesarSolicitudExtranjero}
                    ejecutar={props.ejecutar}
                />
            </Dialog>
        </div>
    );
}
export default connect(mapStateToProps, mapDispatchToProps)(SolicitudesEmpadronamientoDelegacionDialog);